import { styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '21.5rem',
  padding: '0.75rem',
  borderRadius: '0.75rem',
  backgroundColor: '#FEFEFE',
  boxShadow: '0 0.0625rem 0.5rem 0 rgba(0, 0, 0, 0.15)',
  position: 'fixed',
  bottom: '1rem',
  right: '1rem',
  zIndex: theme.zIndex.snackbar,
  fontFamily: theme.typography.fontFamily,
}));

export const Header = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '100%',
  height: '1.5rem',
});

export const HeaderLeft = styled('div')({
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'center',
});

export const HeaderRight = styled('div')({
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'center',
  height: '100%',
});

export const HeaderTitle = styled('p')({
  margin: 0,
  fontFamily: 'Neue Frutiger World',
  fontSize: '0.875rem',
  fontWeight: 500,
  lineHeight: '150%',
  color: '#504E5A',
  whiteSpace: 'nowrap',
});

export const FileCardContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  width: '100%',
  padding: '0.5rem',
  borderRadius: '0.5rem',
  backgroundColor: '#F5F5F7',
});

export const FileRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1rem',
  width: '100%',
  paddingRight: '0.25rem',
});

export const FileThumbnail = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '2.25rem',
  height: '3.1875rem',
  padding: '0.375rem',
  borderRadius: '0.25rem',
  border: '1px solid #DBDBE2',
  backgroundColor: '#F5F5F7',
  boxShadow: '0px 0.0625rem 0.25rem rgba(0, 0, 0, 0.15)',
  flexShrink: 0,
  overflow: 'hidden',
});

export const ThumbnailLine = styled('div')<{ width: string; visible?: boolean }>(
  ({ width, visible = true }) => ({
    height: '1px',
    width,
    borderRadius: '0.625rem',
    backgroundColor: visible ? '#807D93' : 'transparent',
  }),
);

export const FileNameText = styled('p')({
  margin: 0,
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: '160%',
  color: '#504E5A',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const OpenButton = styled('button')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.25rem',
  padding: '0.25rem 0.75rem',
  borderRadius: '0.5rem',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  flexShrink: 0,
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: '160%',
  color: '#737085',
  textAlign: 'center',
  fontFamily: 'inherit',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
});

export const ProgressTrack = styled('div')({
  width: '100%',
  height: '0.4375rem',
  borderRadius: '1.625rem',
  backgroundColor: '#DBDBE2',
  overflow: 'hidden',
});

export const ProgressFill = styled('div')<{ progress: number }>(({ progress }) => ({
  height: '100%',
  width: `${progress}%`,
  borderRadius: '1.875rem',
  backgroundColor: '#31B77A',
  transition: 'width 0.3s ease',
}));

export const FileList = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  width: '100%',
  maxHeight: '50dvh',
  overflowY: 'auto',
});
